<template>
  <div>
    <!-- 問いのカード -->
    <QuestionCard :question="Qdata" />
    <b-card title="コメント欄" class="simple-card-comment">
      <div class="comments-display">
        <p v-if="comments.length == 0">コメントはまだありません</p>
        <div
          v-for="(comment, index) in comments"
          :key="index"
          class="comment-wrapper"
        >
          {{ comment.text }}
        </div>
      </div>
      <div v-if="$store.getters.isSignedIn" class="comment-input">
        <b-form-input
          type="text"
          v-model="commentText"
          placeholder="Leave your comment"
        ></b-form-input>
        <b-button
          size="sm"
          variant="dark m-3"
          class="comment-button"
          v-on:click="saveComment()"
        >
          コメントする
        </b-button>
      </div>
    </b-card>

    <b-card title="問いが投稿された本" class="simple-card-book">
      <div class="flex-row">
        <BookCard :book="bookData" class="left-in-box" />
        <div class="right-in-box">{{ bookData.description }}</div>
      </div>
    </b-card>

    <!--  http://localhost:8080/question/hkeZ7bgGDIQWWGNFd0pxEminxCP2/NDvOKK2Mn3OamTTMGzbw  -->
  </div>
</template>

<script>
import firebase from "firebase";
import { db } from "@/firebase";
import QuestionCard from "@/components/QuestionCard.vue";
import BookCard from "../components/BookCard.vue";

export default {
  data: function() {
    return {
      Qid: this.$route.params.Qid,
      Qdata: {},
      bookData: {},
      comments: [],
      commentText: ""
    };
  },
  components: {
    QuestionCard,
    BookCard
  },
  methods: {
    getQuestion() {
      db.collection("questions")
        .doc(this.Qid)
        .get()
        .then(snapshot => {
          this.Qdata = snapshot.data();
          this.Qdata.id = this.Qid;
          const bookId = snapshot.data().book;
          db.collection("books")
            .doc(bookId)
            .get()
            .then(snapshot2 => {
              this.bookData = snapshot2.data();
              this.bookData.id = bookId;
            });
        });
    },
    getComments() {
      db.collection("questions")
        .doc(this.Qid)
        .collection("comments")
        .orderBy("createdAt", "desc")
        .onSnapshot(snapshot => {
          let comments = [];
          snapshot.forEach(comment => {
            comments.push(comment.data());
          });
          this.comments = comments;
        });
    },
    saveComment() {
      db.collection("questions")
        .doc(this.Qid)
        .collection("comments")
        .doc()
        .set({
          text: this.commentText,
          user: this.$store.getters.user.id,
          createdAt: firebase.firestore.FieldValue.serverTimestamp()
        });
      this.commentText = "";
      // const commentContainer = document.getElementById("comments-display");
      // while (commentContainer.firstChild) {
      //   commentContainer.removeChild(commentContainer.firstChild);
      // }
      // //reloadの役割↓
      // this.getComments();
    },
    goToBookDetail() {
      console.log(this.bookData);
      this.$router.push("/book/" + this.bookData.id);
    }
  },
  created() {
    this.getQuestion();
    this.getComments();
  }
};
</script>

<style lang="scss">
.comments-display {
  border-top: 1px solid black;
  margin: auto;
}
.simple-card-comment {
  margin: 20px 1.5%;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.12), 0 2px 3px 0 rgba(0, 0, 0, 0.22);
}
.simple-card-book {
  margin: 20px 1.5%;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.12), 0 2px 3px 0 rgba(0, 0, 0, 0.22);
}
.right-in-box {
  width: 50%;
}
.comment-wrapper {
  border: 1px solid black;
  border-radius: 5px;
  margin: 5px auto;
  padding: 5px;
  font-size: 15px;
  width: 100%;
}
</style>
